import { createElement } from 'react'
import { createRoot } from 'react-dom/client'

// data-react-component 属性を持つ要素に React コンポーネントをマウントする。
//
// 使い方 (Rails view):
//   <div data-react-component="ExampleComponent" data-props='<%= { name: "World" }.to_json %>'></div>
//
// コンポーネントをここに追加する
import ExampleComponent from '~/components/ExampleComponent'

const COMPONENTS = {
  ExampleComponent,
}

export function mountComponents() {
  document.querySelectorAll('[data-react-component]').forEach((el) => {
    const name = el.dataset.reactComponent
    const Component = COMPONENTS[name]
    if (!Component) {
      console.warn(`[React] Component not found: ${name}`)
      return
    }
    const props = el.dataset.props ? JSON.parse(el.dataset.props) : {}
    createRoot(el).render(createElement(Component, props))
  })
}
